// extracted by mini-css-extract-plugin
export default {"list":"FAQ_list__mGUSW","item":"FAQ_item__uZqsb","question":"FAQ_question__B-00A","answer":"FAQ_answer__FIhw-"};